export const DEALER_AUTH_COOKIE_NAME = 'dealerAuthToken';

export function parseCookiesFromString(cookieString: string): Record<string, string> {
    const cookies: Record<string, string> = {};
    if (!cookieString) {
        return cookies;
    }

    return cookieString.split(';').reduce((cookies, cookie) => {
        const [key, ...value] = cookie.split('=');
        cookies[decodeURIComponent(key.trim())] = decodeURIComponent(value.join('=').trim());
        return cookies;
    }, cookies);
}
